/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FboLocationResponse } from '../../models/fbo-location-response';
import { UpdateFboLocationRequestDto } from '../../models/update-fbo-location-request-dto';

export interface UpdateFboLocation$Params {

/**
 * The ID of the FBO location to update.
 */
  id: number;
      body: UpdateFboLocationRequestDto
}

export function updateFboLocation(http: HttpClient, rootUrl: string, params: UpdateFboLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<FboLocationResponse>> {
  const rb = new RequestBuilder(rootUrl, updateFboLocation.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FboLocationResponse>;
    })
  );
}

updateFboLocation.PATH = '/api/administration/fbo-locations/{id}';
